/** @format */

import React, {useState} from 'react';
import SuperAgent from 'superagent';
import {
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_LABEL
} from 'frontier-constants';
import {createAndClickOpen} from 'frontier/utilities/download';

export const useDuplicateOrder = id => {
    const [isPending, setIsPending] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleDuplicate = async () => {
        setIsPending(true);
        const response = await SuperAgent.post('/carts/duplicate-order/' + id).set(
            'accept',
            'application/json'
        );
        if (response?.body?.newOrder) {
            const newOrder = response.body.newOrder;
            setSuccess(true);

            switch (newOrder.product_type_id) {
                case PRODUCT_TYPE_LABEL:
                    createAndClickOpen('/orders/custom-labels/' + newOrder.id);
                    break;
                case PRODUCT_TYPE_CARTON:
                    createAndClickOpen('/orders/custom-cartons/' + newOrder.id);
                    break;
                case PRODUCT_TYPE_GRAPHIC_DESIGN:
                    createAndClickOpen('/orders/custom-design/' + newOrder.id);
                    break;
            }
        } else {
            setSuccess(false);
        }

        setIsPending(false);
    };

    return {
        handleDuplicate,
        isPending,
        success
    };
};
